import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { ItemssearchComponent } from '../itemssearch/itemssearch.component';
import { StockTrnDetModel } from 'src/app/models/StockTrnModel';
import { formatDate } from '@angular/common';
import { StockTrnService } from 'src/app/services/StockTrnService';
import swal from 'sweetalert2';

@Component({
  selector: 'app-acc-invoice-edit',
  templateUrl: './acc-invoice-edit.component.html',
  styleUrls: ['./acc-invoice-edit.component.css']
})
export class AccInvoiceEditComponent implements OnInit {
  dettype = '21' ;
  detserial = 0 ;
  detline = 0 ;
  detitem = '' ;
  detitemname = '' ;
  detqty = 0 ;
  detprice = 0 ;
  detvalue = 0 ;
  detdescription = '' ;
  detstatus = '';
  stockdet : StockTrnDetModel[] = []; 

  constructor(public itemsservice : ItemsService,
    public storage: LocalStorageService,
    private dialogref: MatDialog,
    public translate: TranslateService,
    public items : ItemsModel,
    public stocktrndet : StockTrnDetModel,
    public stocktrnservicse : StockTrnService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dettype = data.dettype,
      this.detitem = data.detitem;
      this.detline = data.detline;
      this.detitemname = data.detitemname;
      this.detprice = data.detprice;
      this.detqty =  data.detqty;
      this.detvalue = data.detvalue;
      this.detserial = data.detserial;
      this.detdescription =data.detdescription;
      this.stockdet= data.stockdet;
      this.detstatus = data.detstatus;

  }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
    console.log("this.stockdet",this.stockdet)
  }
  GetValue(){
    this.detvalue = this.detqty * this.detprice;
  }
  RetriveItems(){

     // this.detdescription = '';
    for (let i = 0; i < this.stockdet.length; i++) {
     if (this.stockdet[i].detitem.toLowerCase() == this.detitem.toLowerCase()){ this.messagewarrning();return; }

  }
    this.itemsservice.getitems(this.detitem, this.storage.retrieve('stgcompcode')).subscribe((data: ItemsModel) => {

      this.detitemname = data.itTName;
      this.detprice = data.iTMedical;
      this.detstatus = '';

    }
    )
  }
  OpenDialogItem(){

    const dialogRef = this.dialogref.open(ItemssearchComponent,
          {
            data: {
              dataKey: this.items,

            }
          });

        dialogRef.afterClosed().subscribe(result => {

        });

        const dialogSubmitSubscription =

        dialogRef.componentInstance.submitClicked.subscribe(result => {
          for (let i = 0; i < this.stockdet.length; i++) {
            if (this.stockdet[i].detitem.toLowerCase() == result.itCode.toLowerCase()){ this.messagewarrning();return; }

             }
            this.detitem = result.itCode;
            this.detitemname = result.itTName;
            this.detprice = result.iTMedical;

            this.GetValue();
            dialogSubmitSubscription.unsubscribe();
          });


  }
  submitLine(){
    if (this.detitem == '' || this.detitem == null) {
      return;
    }

    this.stocktrndet.dettype = this.dettype;
    this.stocktrndet.detserial = this.detserial;
    this.stocktrndet.detline = this.detline;
    this.stocktrndet.detitem = this.detitem;
    this.stocktrndet.detitemname = this.detitemname;
    this.stocktrndet.detqty = this.detqty;
    this.stocktrndet.detprice = this.detprice;
    this.stocktrndet.detvalue = this.detvalue;
    this.stocktrndet.detdescription = this.detdescription;

    this.stocktrndet.userid = this.storage.retrieve('stguserId');
    this.stocktrndet.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.stocktrndet.compcode = this.storage.retrieve('stgcompcode');
    this.stocktrnservicse.AddStockTrnDet(this.stocktrndet).subscribe(data => {
    this.CloseDialog()
    },
      error => { alert(error); }
    );
  }
  DeleteLine(){
    this.stocktrnservicse.DelStockTrnDetLine(this.dettype, this.detserial.toString(),this.detline.toString(), this.storage.retrieve('stgcompCode')).subscribe(
      (data: StockTrnDetModel) => {
      }
    );
  }
  mesgDelete(){
   swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(
        () => {
          this.DeleteLine();
          swal('Deleted!', 'Your record has been deleted.', 'success');
          this.CloseDialog();
        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );

  }
  messagewarrning(){
    swal({
      title: 'هذا البند مكرر .... نرجو التأكد',
      type: 'error',
      showConfirmButton: false,

      timer: 2500,
    });

  }
  CloseDialog(){
    this.dialogref.closeAll();
  }
}
